module.exports = __webpack_public_path__ + "img/4.07.thmb.3b751b44.jpg";